export default __webpack_public_path__ + "static/media/Technical.76190b43.png";